var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Search } from "@mui/icons-material";
import { useMediaQuery } from "@mui/system";
import { FilterIcon } from "../../../../assets/customIcons";
import { MoreIconNew } from "../../../../assets/images";
import ActionMenuList from "../../../../builderPackage/components/actionsMenuList";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DesktopTabComponent } from "../../../../components/molecules/desktopTabComponent";
import { showSurface } from "../../../../redux/awaitedSurfacesSlice";
import { useAppDispatch } from "../../../../store/hooks";
import ActionTakePopup from "../components/actionTakepopup";
import AFRsCatalog from "../components/AFRsCatalog";
import { AFRsMobileView } from "../components/AFRsMobileView";
import PSGFilter from "../components/PSGFliter";
var ReceivedAFRs = function () {
    var dispatch = useAppDispatch();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            alignItems: 'center',
            sx: {
                justifyContent: {
                    xs: "space-between",
                    sm: 'start'
                },
                padding: {
                    xs: '16px 16px',
                    md: '16px 24px'
                }
            },
            gap: '12px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    spacing: 0,
                    sx: {
                        alignItems: 'center',
                        gap: '12px'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Received AFRs',
                            columnSize: 0,
                            sx: {
                                fontWeight: 'strong',
                                fontSize: 'xxl'
                            }
                        }, {
                            type: FormItemTypes.Chip,
                            name: '',
                            variant: 'filled',
                            color: 'info',
                            shape: 'rounded',
                            label: '1000',
                            columnSize: 0
                        }]
                }, isMobile ? {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: MoreIconNew,
                        alt: ""
                    }),
                    columnSize: 0,
                    onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        containerProps: {
                                            anchorEl: e.target.parentElement
                                        },
                                        Component: ActionMenuList,
                                        componentProps: {
                                            items: [{
                                                    id: 'ResendToASM',
                                                    children: "Resend to ASM"
                                                }, {
                                                    id: 'Accept&Group',
                                                    children: "Accept & group"
                                                }, {
                                                    id: 'CloseAFR',
                                                    children: 'Close AFR'
                                                }]
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    if (!(res !== null && res !== void 0 && res.payload)) return [3 /*break*/, 3];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: ActionTakePopup,
                                            containerProps: {
                                                anchor: 'bottom',
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: "12px 12px 0 0"
                                                    }
                                                }
                                            }
                                        }))];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }
                } : null]
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '76px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    sx: {
                        maxWidth: {
                            xs: 400,
                            sm: 200,
                            md: 300
                        }
                    },
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'search',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search ...',
                            InputProps: {
                                disableUnderline: true
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: isMobile ? 2 : 9,
                    gap: isMobile ? '0px' : '12px',
                    elements: [!isMobile ? {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            justifyContent: 'end',
                            sx: {
                                gap: {
                                    xs: '8px',
                                    sm: '8px',
                                    md: '12px'
                                }
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Resend to ASM',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: ActionTakePopup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Accept & group',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: ActionTakePopup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Close AFR',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: ActionTakePopup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }]
                        } : null, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: "".concat(!isMobile ? "Filters" : ''),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: PSGFilter,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: {
                                                                xs: '100%',
                                                                sm: '350px'
                                                            },
                                                            borderRadius: {
                                                                xs: '8px 8px 0 0'
                                                            }
                                                        }
                                                    },
                                                    anchor: isMobile ? 'bottom' : 'right'
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 12,
                    element: isMobile ? AFRsMobileView : AFRsCatalog
                }]
        }];
    var list = [{
            id: 1,
            DisplayName: 'Dashboard ',
            Name: 'Dashboard'
        }, {
            id: 2,
            DisplayName: 'Received AFRs',
            Name: 'Received AFRs'
        }, {
            id: 3,
            DisplayName: 'IRs',
            Name: ''
        }, {
            id: 3,
            DisplayName: 'Utility',
            Name: ''
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0
        },
        formData: formData
    }));
};
export default ReceivedAFRs;
